import React from "react";
import {FormattedMessage} from "react-intl";
import { console } from "window-or-global";

const errorMessage = {
  "EBUILDING": "error.noBuilding",
  "EBUILDINGADDRESS": "error.noBuildingAddress",
  "EVOUCHER": "error.invalidVoucher",
  "ESERVICE": "error.noService",
  "EACTIVE": "error.serviceActive",
  "EVERIFICATIONCODE": "error.verificationCode",
  "EINVALIDPLANS": "error.invalidPlans",
  "EUNKNOWN": "error.unknown",
  "Email is already registered": "error.existingEmail",
  "Invalid EWAY_CARDNUMBER": "error.invalidCard",
  "proper_email": "error.properEmail",
  "Invalid captcha code provided": "error.invalidCaptcha",
  "ENOACCOUNT": "error.noAccount",
  "EINVALIDPRODUCT": "error.invalidProducts",
};

export default function catchErrorMessage(message) {
  const result = errorMessage[message];
  if (!result) {
    return message || "";
  }

  return (<FormattedMessage id={result} />);
}
